import { render, staticRenderFns } from "./pricelist-preview.vue?vue&type=template&id=0ccad498&"
import script from "./pricelist-preview.vue?vue&type=script&lang=js&"
export * from "./pricelist-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports